// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Q9dY","title":"Info_title__6z4qA","selects":"Info_selects__1SJIr","requiredAsterisk":"Info_requiredAsterisk__e77e_"};